import React from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav
      className="navbar"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        padding: '1rem',
        display: 'flex', // Horizontal layout
        justifyContent: 'flex-start',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Link
        to="home"
        smooth={true}
        duration={500}
        style={{
          margin: '0 1rem',
          cursor: 'pointer',
          color: 'white',
          textDecoration: 'none',
        }}
      >
        Home
      </Link>
      <Link
        to="services"
        smooth={true}
        duration={500}
        style={{
          margin: '0 1rem',
          cursor: 'pointer',
          color: 'white',
          textDecoration: 'none',
        }}
      >
        Leistungen
      </Link>
      <Link
        to="about"
        smooth={true}
        duration={500}
        style={{
          margin: '0 1rem',
          cursor: 'pointer',
          color: 'white',
          textDecoration: 'none',
        }}
      >
        Über mich 
      </Link>
      <Link
        to="contact"
        smooth={true}
        duration={500}
        style={{
          margin: '0 1rem',
          cursor: 'pointer',
          color: 'white',
          textDecoration: 'none',
        }}
      >
        Kontakt
      </Link>
    </nav>
  );
};

export default Navbar;
